import { graphql } from '@/graphql-setup'

export const INFO_CONTENT_QUERY = graphql(`
  query InfoContentQuery($page: String!, $language: String!) {
    infoContent(page: $page, language: $language) {
      id
      text
      videoUrl
      language
      page
    }
  }
`)
